/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GlobalOverallCommentsCountDeltaQueryVariables = Types.Exact<{
  isUserAllowedToReadComments: Types.Scalars['Boolean'];
  surveyContentType: Types.SurveyContentType;
}>;


export type GlobalOverallCommentsCountDeltaQuery = { commentsStatistics: { overallCommentsCountDelta: number } };


export const GlobalOverallCommentsCountDeltaDocument = gql`
    query GlobalOverallCommentsCountDelta($isUserAllowedToReadComments: Boolean!, $surveyContentType: SurveyContentType!) {
  commentsStatistics: getStatisticsGlobal(surveyContentType: $surveyContentType) @include(if: $isUserAllowedToReadComments) {
    overallCommentsCountDelta: number_of_recipient_comments_delta
  }
}
    `;

/**
 * __useGlobalOverallCommentsCountDeltaQuery__
 *
 * To run a query within a React component, call `useGlobalOverallCommentsCountDeltaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOverallCommentsCountDeltaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOverallCommentsCountDeltaQuery({
 *   variables: {
 *      isUserAllowedToReadComments: // value for 'isUserAllowedToReadComments'
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useGlobalOverallCommentsCountDeltaQuery(baseOptions: Apollo.QueryHookOptions<GlobalOverallCommentsCountDeltaQuery, GlobalOverallCommentsCountDeltaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalOverallCommentsCountDeltaQuery, GlobalOverallCommentsCountDeltaQueryVariables>(GlobalOverallCommentsCountDeltaDocument, options);
      }
export function useGlobalOverallCommentsCountDeltaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalOverallCommentsCountDeltaQuery, GlobalOverallCommentsCountDeltaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalOverallCommentsCountDeltaQuery, GlobalOverallCommentsCountDeltaQueryVariables>(GlobalOverallCommentsCountDeltaDocument, options);
        }
export type GlobalOverallCommentsCountDeltaQueryHookResult = ReturnType<typeof useGlobalOverallCommentsCountDeltaQuery>;
export type GlobalOverallCommentsCountDeltaLazyQueryHookResult = ReturnType<typeof useGlobalOverallCommentsCountDeltaLazyQuery>;
export type GlobalOverallCommentsCountDeltaQueryResult = Apollo.QueryResult<GlobalOverallCommentsCountDeltaQuery, GlobalOverallCommentsCountDeltaQueryVariables>;